export default __webpack_public_path__ + "static/char-s-15-chs-0182cc1483f657ebca449572477e12f6.webp";